import { api_configuration } from "../../common";
import api_report = api_configuration.report_protocol_types;
import messages = require("../front/messages");

const REPORT_MANAGE_URL = "report-manage"; // FIXME: configure the report manage URL.
const REPORT_DOWNLOAD_URL = "report-download"; // FIXME: configure the report download URL

function performInBrowserHttpRequest(
	browser_specific_http_request: XMLHttpRequest,
	url: string,
	post_data: string,
	listener: { handleSuccess: any; handleFailure: any }
) {
	browser_specific_http_request.onload = function () {
		if (this.status >= 200 && this.status < 300) {
			if (browser_specific_http_request.responseType === "blob") {
				listener.handleSuccess(browser_specific_http_request.response);
			} else {
				listener.handleSuccess(browser_specific_http_request.responseText);
			}
		} else {
			listener.handleFailure("Bad status code: " + this.status);
		}
	};
	browser_specific_http_request.onabort = function () {
		listener.handleFailure("Request aborted.");
	};
	browser_specific_http_request.onerror = function () {
		listener.handleFailure("Request error.");
	};
	browser_specific_http_request.open("POST", url);
	browser_specific_http_request.setRequestHeader("Content-Type", "application/json");
	browser_specific_http_request.send(post_data);
}

export function post_to_report_resource(
	report_request: api_report.report_protocol_request.alan_api.Creport_protocol_request,
	response_handler?: (response: api_report.report_protocol_reply.alan_api.Creport_protocol_reply) => void
): void {
	performInBrowserHttpRequest(
		new XMLHttpRequest(),
		REPORT_MANAGE_URL,
		JSON.stringify(api_report.report_protocol_request.serializer_json.serialize(report_request)),
		{
			handleSuccess: function (file_content: string) {
				if (response_handler) {
					response_handler(
						api_report.report_protocol_reply.alan_api.Creport_protocol_reply.create(JSON.parse(file_content))
					);
				}
			},
			handleFailure: function (error: string) {
				console.warn(error);
				messages.addMessage("warning", "Something went wrong. Please try again.");
			},
		}
	);
}

export function download_from_report_resource(
	report_request: api_report.report_protocol_download_request.alan_api.Creport_protocol_download_request,
	response_handler: (report: any) => void
): void {
	const req = new XMLHttpRequest();
	req.responseType = "blob";
	performInBrowserHttpRequest(
		req,
		REPORT_DOWNLOAD_URL,
		JSON.stringify(api_report.report_protocol_download_request.serializer_json.serialize(report_request)),
		{
			handleSuccess: function (file_content: any) {
				response_handler(file_content);
			},
			handleFailure: function (error: string) {
				console.warn(error);
				messages.addMessage("warning", "Something went wrong. Please try again.");
			},
		}
	);
}
